import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContractScreenComponent} from './screen/contract-screen.component';
import {StoreModule} from "@ngrx/store";
import {EffectsModule} from "@ngrx/effects";
import {ContractsEffects} from "./core/contracts.effects";
import {reducer} from "./core/contracts.reducer";
import {SharedModule} from "../../shared/shared.module";
import {MaterialModule} from "../../shared/material-module";


@NgModule({
  declarations: [
    ContractScreenComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('ss-cord.contracts', reducer),
    EffectsModule.forFeature(
      [ContractsEffects]
    ),
    MaterialModule,
  ]
})
export class ContractsModule {}
